var farmingTypeManager = require('@managers/farmingTypeManager');
var { error_message } = require('@managers/helpers');

// Middleware
export var load_farming_type_data = (force = false) => {
  return (dispatch, getState) => {
    var state = getState();
    // Load only once
    if (!state.farming_type_data.farming_type_data || force) {
      dispatch(get_farming_type_data_init());

      farmingTypeManager.farmingTypeData().then(
        function (result) {
          dispatch(get_farming_type_data_success(result));
        },
        function (err) {
          console.log(err);
          dispatch(get_farming_type_data_fail(err));
        }
      );
    }
  };
};

export var get_farming_type_data_init = () => {
  return {
    type: 'GET_FARMING_TYPE_DATA_INIT',
  };
};

export var get_farming_type_data_success = farming_type_data => {
  return {
    type: 'GET_FARMING_TYPE_DATA_SUCCESS',
    farming_type_data: farming_type_data,
  };
};

export var get_farming_type_data_fail = err => {
  return {
    type: 'GET_FARMING_TYPE_DATA_FAIL',
    error_message: error_message(err),
  };
};

export var clear_farming_type_data_actions = () => {
  return {
    type: 'CLEAR_FARMING_TYPE_DATA_ACTIONS',
  };
};
